import { css } from 'aphrodite';
import { Dialog, DialogBody, DialogPopup, DialogTitle } from '../../components-v2/Dialog';
import { LoadingSpinner } from '../LoadingSpinner';
import { styleSheet } from './styles';
import { TestimonialCreationStep } from './types';

const STEP_MESSAGES: Record<TestimonialCreationStep, string> = {
	generating: 'Generating your testimonial image...',
	creating: 'Adding it to a new draft post...',
};

export const TestimonialCreationDialog = ({ step }: { step: TestimonialCreationStep | null }) => (
	<Dialog open={step !== null} dismissOnOutsideClick={false}>
		<DialogPopup showCloseButton={false} styles={[styleSheet.creationDialog]}>
			<DialogBody styles={[styleSheet.creationDialogBody]}>
				<LoadingSpinner type='large' />
				<DialogTitle styles={[styleSheet.creationDialogTitle]}>Creating your post</DialogTitle>
				<p className={css(styleSheet.creationDialogStep)}>{step ? STEP_MESSAGES[step] : null}</p>
			</DialogBody>
		</DialogPopup>
	</Dialog>
);
